import React, { Component } from 'react';
import _, { isEmpty } from 'lodash';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { MoreVertRounded, PrintRounded, QrCode2Rounded } from '@mui/icons-material';

import Dialog from '../../../common/Dialog';
import TableWithFilters from '../../../common/TableWithFilters';
import DeleteDialog from '../../../common/DeleteDialog';
import GenerateQrCode from '../List/GenerateQrCode';
import Equipements from '../Forms/Equipements';
import EquipementPics from '../Forms/EquipementPics';

class SingleList extends Component {
    state = {  
        type: "",
        openQR: false,
        selected: {},
        openFilters: false,
        openUpdate: false,
        openUpdatePics: false,
        anchorEl: null, 
        openMenu: "", 
        openDelete: false, 
        toDelete: {},
    }
    handleOpenUpdate = (data, form = "openUpdate", open = true) => {
        this.setState({
			selected: data ,
            [form]: open,
            openMenu: "",
            anchorEl: null
		})
    }
    handleDelete = async () => {
        const { selected } = this.state;
        await this.props.deleteEquipement(selected)
        if(this.props.STATE.equipements.error){
            this.props.notif("error", this.props.STATE.equipements.error)
        } else {
            this.props.notif("success", "Équipement supprimé")
            this.setState({
                openDelete: false,
                selected: {},
            })
        }
    }
    displayTags = (tags) => {
        const { IMMO_TAGS } = this.props;
        
        return tags.split(', ').map(tag => IMMO_TAGS && IMMO_TAGS[tag] && `#${IMMO_TAGS[tag].immo_tag_name}`).join(" ")
    }


    render() {
        const { EQUIPEMENTS, LOCALISATIONS, EQUIPLIST } = this.props;
        const { openQR, selected, openUpdate, openDelete, anchorEl, openMenu, openUpdatePics, openPrint } = this.state;

        console.log('====================================');
        console.log(this.state);
        console.log('====================================');

        return (
            <Dialog
                close={this.props.close}
                maxWidth="xl"
                // fullScreen
                scroll="paper"
                title={`${EQUIPLIST.equipement_original_name} x ${EQUIPLIST.equipement_quantity}`}
                // appBar
            >
                {openDelete && !isEmpty(selected) &&
                    <DeleteDialog
                        title={"l'equipement"}
                        close={() => this.setState({
                            openDelete: false,
                            selected: {},
                        })}
                        notif={this.props.notif}
                        handleSubmit={this.handleDelete}
                        disabledSubmit={this.props.STATE.equipements.fetching}
                    >
                        Equipement : {selected.equipement_name} <br />
                        Référence: {selected.equipement_ref}
                    </DeleteDialog>
                }
                {openQR && !isEmpty(selected) &&
                    <GenerateQrCode 
                        equipement={selected} 
                        handleClose={()=> this.setState({ openQR: false })}
                    />
                }
                {openUpdate && !isEmpty(selected) &&
                    <Equipements
                        update
                        equipement={this.state.selected}
                        type={this.state.selected.equipement_type}
                        {...this.props}
                        handleClose={() => this.handleOpenUpdate({}, "openUpdate", false)}
                    />
                }
                {openUpdatePics && !isEmpty(selected) &&
                    <EquipementPics
                        update
                        equipement={this.state.selected}
                        type={this.state.selected.equipement_type}
                        {...this.props}
                        handleClose={() => this.handleOpenUpdate({}, "openUpdatePics", false)}
                    />
                }

                {!isEmpty(EQUIPEMENTS) && !isEmpty(LOCALISATIONS.CHILD) && 
                    <TableWithFilters
                        internalId="equipement_id"
                        rows={Object.values(EQUIPEMENTS).filter(i => i.equipement_original_name === EQUIPLIST.equipement_original_name)}
                        rowHeight={50}
                        getRowStyle={this.getRowStyle}
                        filterList={this.handleFilters}
                        columns={[
                            {
                                field: 'equipement_unique_ref',
                                headerName: 'Référence Produit', 
                                width: 200,
                                renderCell: (params) => (
                                    <span 
                                        onClick={
                                            () => this.props.handleSingle(params.row)
                                        }
                                    >
                                        {params.row.equipement_unique_ref}
                                    </span>
                                ),
                            },
                            {
                                field: 'equipement_ref',
                                headerName: 'Référence Unique', 
                                width: 200,
                                renderCell: (params) => (
                                    <span 
                                        onClick={
                                            () => this.props.handleSingle(params.row)
                                        }
                                    >
                                        {params.row.equipement_ref}
                                    </span>
                                ),
                            },
                            {
                                field: 'equipement_name',
                                headerName: 'Intitulé', 
                                width: 500,
                                renderCell: (params) => (
                                    <span className="a-like" onClick={() => this.props.handleSingle(params.row)}>{params.row.equipement_name}</span>
                                ),
                            },
                            {
                                field: 'equipement_date_acquisition',
                                headerName: "Aquisition", 
                                // valueGetter: (params) => `${new Date(params.row.equipement_date_acquisition).toLocaleDateString("fr-FR")}`,
                                renderCell: (params) => (
                                    <span>{
                                        new Date(params.row.equipement_date_acquisition).getFullYear() > 1 ? 
                                        `${new Date(params.row.equipement_date_acquisition).toLocaleDateString("fr-FR")}` : 
                                        "--"
                                    }
                                    </span>

                                ),
                                width: 150
                            },
                            {
                                field: 'equipement_date_service',
                                headerName: "Mise en service", 
                                // valueGetter: (params) => `${new Date(params.row.equipement_date_acquisition)}`,
                                renderCell: (params) => (
                                    <span>{
                                        new Date(params.row.equipement_date_service).getFullYear() > 1 ? 
                                        `${new Date(params.row.equipement_date_service).toLocaleDateString("fr-FR")}` : 
                                        "--"
                                    }
                                    </span>

                                ),
                                width: 150
                            },
                            {
                                field: 'loc',
                                headerName: 'Localisation', 
                                width: 150,
                                sortable: true,
                                valueGetter: (params) =>
                                `${LOCALISATIONS.CHILD[params.row.equipement_localisation].loc_name}`,
                            },
                            // {
                            //     field: 'tag',
                            //     headerName: 'Tag', 
                            //     width: 150,
                            //     sortable: true,
                            //     valueGetter: (params) => this.displayTags(params.row.equipement_tags),
                            // },
                            {
                                field: 'dispo',
                                headerName: 'Dispo', 
                                width: 100,
                                sortable: true,
                                valueGetter: (params) => `${params.row.equipement_available ? 'OUI' : 'NON'}`,
                            },
                            {
                                field: 'qr',
                                headerName: 'QR code',
                                width: 100,
                                sortable: false,
                                renderCell: (params) => (
                                    <IconButton onClick={ () => this.setState({ openQR : true, selected: params.row })}>
                                        <QrCode2Rounded />
                                    </IconButton>
                                ),
                            },
                            {
                                field: 'actions',
                                headerName: 'Actions',
                                sortable: false,
                                width: 100,
                                renderCell: (params) => (
                                    // params.row.equipement_is_new ?
                                    
                                    <>
                                    <IconButton 
                                        aria-controls={`option-menu${params.row.equipement_id}`} 
                                        aria-haspopup="true"
                                        onClick={(event) => this.setState({ anchorEl: event.currentTarget, openMenu : params.row.equipement_id}) }>
                                        <MoreVertRounded />
                                    </IconButton>

                                    <Menu
                                        MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                        }}
                                        id={`option-menu${params.row.equipement_id}`}
                                        anchorEl={anchorEl}                                               
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={ openMenu === params.row.equipement_id}
                                        onClose={() => this.setState({ openMenu: "", anchorEl: null})}
                                    >
                                        {!params.row.equipement_available && !params.row.no_loan &&
                                            <MenuItem onClick={() => this.props.handleOpenReturn(params.row) } >Restitution</MenuItem>    
                                        }   
                                        {params.row.equipement_available &&
                                            <>    
                                                <MenuItem onClick={() => this.props.handleOpenAttribute(params.row) } >Attribution</MenuItem>    
                                                <MenuItem onClick={() => this.handleOpenUpdate(params.row) } >Modifier</MenuItem>                
                                                <MenuItem onClick={() => this.handleOpenUpdate(params.row, "openUpdatePics") } >Modifier Photos</MenuItem>                
                                                <MenuItem 
                                                    onClick={() => this.handleOpenUpdate(params.row, "openDelete") }
                                                >
                                                    Supprimer
                                                </MenuItem>
                                            </>
                                        }
                                        {params.row.no_loan &&
                                            <>    
                                                <MenuItem onClick={() => this.handleOpenUpdate(params.row) } >Modifier</MenuItem>                
                                                <MenuItem onClick={() => this.handleOpenUpdate(params.row, "openUpdatePics") } >Modifier Photos</MenuItem>                
                                                <MenuItem 
                                                    onClick={() => this.handleOpenUpdate(params.row, "openDelete") }
                                                >
                                                    Supprimer
                                                </MenuItem>
                                            </>
                                        }
                                    </Menu>
                                    </>
                                
                                ),
                            },
                        ]}
                    />
                }
            </Dialog>
        );
    }
}

export default SingleList;